import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex min-h-11 items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-medium transition-[color,background-color,border-color,box-shadow,scale] duration-150 ease-out disabled:pointer-events-none disabled:opacity-50 md:min-h-10 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default:
          "bg-transparent text-primary border border-primary shadow-[2px_2px_0_0_#EFC846] hover:bg-primary/5",
        destructive:
          "bg-destructive text-white hover:bg-destructive/90 focus-visible:ring-destructive/20",
        destructive2:
          "border border-red-200 text-red-700 hover:bg-red-50 hover:text-red-800 rounded-md",
        outline:
          "border bg-background hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        neutral:
          "border rounded-md bg-background  hover:bg-accent hover:text-accent-foreground",
        yellow:
          "bg-secondary/80 text-secondary-foreground hover:bg-secondary rounded-md",
        black: "bg-text-primary text-white hover:bg-black rounded-md",
        gray: "bg-[#F2F2F2] text-text-primary hover:bg-[#EBEBEB] rounded-md",
        blue: "bg-background-primary rounded-md border border-background-primary hover:bg-[#E0F0FF] hover:border-[#E0F0FF]",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        ghost2:
          "border-transparent border hover:border hover:border-stroke-primary hover:bg-muted hover:bg-background-secondary",
        link: "text-primary underline-offset-4 hover:underline",
        update:
          "rounded-full bg-background-primary text-primary hover:bg-[#D9EBFF]",
      },
      size: {
        default: "h-11 px-4 py-2 has-[>svg]:px-3 md:h-10",
        xs: "h-11 gap-1 px-2 text-xs has-[>svg]:px-1.5 md:h-10 [&_svg:not([class*='size-'])]:size-3",
        sm: "h-11 gap-1.5 px-3 has-[>svg]:px-2.5 md:h-10",
        lg: "h-11 px-6 has-[>svg]:px-4 md:h-10",
        icon: "size-11 md:size-10",
        "icon-xs": "size-11 rounded-md md:size-10 [&_svg:not([class*='size-'])]:size-3",
        "icon-sm": "size-11 md:size-10",
        "icon-lg": "size-11 md:size-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);
